export default __webpack_public_path__ + "phone@2x.fa53d6dd.png";